import { UserRoles } from "./utils";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { ControlledSelect, ControlledTextField } from '../../shared/components/controlledInput/ControlledInputs';
import { useEffect, useMemo, useRef } from 'react';
import CircularProgress from "@mui/material/CircularProgress";

export const UpdateUserModal = ({ show, handleUpdate, handleClose, lngsltd, userToEdit, storeLocations, updating }) => {
    const submitCountRef = useRef(0); // counter to stop submit 2 times
    const { handleSubmit, control, formState: { errors, isValid }, reset } = useForm({
        mode: "onChange",
        defaultValues: {
            firstName: "",
            lastName: "",
            password: "",
            role: "",
            store: ""
        }
    });

    useEffect(() => {
        if (userToEdit) {
            // rest counting 
            submitCountRef.current = 0;
            const defaultFormData = {
                firstName: userToEdit.firstName || "",
                lastName: userToEdit.lastName || "",
                password: "",
                role: userToEdit.role,
                store: userToEdit.storeId
            }
            reset(defaultFormData); // This will re-initialize the form with fetched user data
        }
    }, [userToEdit, reset]);

    const storeOptions = useMemo(() => {
        return Object.keys(storeLocations).map(storeID => ({
            label: storeLocations[storeID],
            value: storeID,
        }))
    }, [storeLocations])

    const onSubmit = (data) => {
        if (submitCountRef.current >= 1) {
            handleUpdate(userToEdit.userEmail, data)
        }
        submitCountRef.current += 1;
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle id="dialog-title" style={{ backgroundColor: '#efedf0' }}>
                    {lngsltd["Update details"]}
                </DialogTitle>
                <DialogContent>
                    <ControlledTextField
                        name="firstName"
                        control={control}
                        label="First Name *"
                        rules={{ required: "First Name is required" }}
                        error={errors.firstName}
                        helperText={errors.firstName?.message}
                    />

                    <ControlledTextField
                        name="lastName"
                        control={control}
                        label="Last Name *"
                        rules={{ required: "Last Name is required" }}
                        error={errors.lastName}
                        helperText={errors.lastName?.message}
                    />

                    <ControlledTextField
                        name="password"
                        control={control}
                        label="Password *"
                        type="password"
                        rules={{
                            pattern: {
                                value: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
                                message: "Password must contain at least 8 characters, including one capital letter, one number, and one symbol",
                            },
                        }}
                        error={errors.password}
                        helperText={errors.password?.message}
                    />

                    <ControlledSelect
                        name="role"
                        control={control}
                        label={lngsltd["Role"]}
                        rules={{ required: "Role is required" }}
                        error={errors.role}
                        helperText={errors.role?.message}
                        options={UserRoles.map(role => ({ label: role, value: role }))}
                    />

                    <ControlledSelect
                        name="store"
                        control={control}
                        label={lngsltd["Store Location"]}
                        type="select"
                        options={storeOptions}
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained" color="primary" disabled={!isValid || updating}>
                        {updating ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            lngsltd["Update"]
                        )}
                    </Button>
                    <Button variant="outlined" color="error" onClick={handleClose} style={{ marginLeft: 8 }}>
                        {lngsltd["Cancel"]}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
